module.exports = __webpack_public_path__ + "static/bkg-webchefs.a5fc16f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bkg-webchefs.jpg
// module id = 603
// module chunks = 35783957827783